export const REDUCE_MOTION_CHANNEL_NAME = 'reduceMotion';
export const REDUCE_MOTION_STORAGE_KEY = 'reduceMotion';

export function getReduceMotion(): boolean {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem(REDUCE_MOTION_STORAGE_KEY);
    if (saved !== null) {
      return JSON.parse(saved);
    }
  }
  return false;
}

export function setReduceMotion(newValue: boolean) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(REDUCE_MOTION_STORAGE_KEY, JSON.stringify(newValue));
    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel(REDUCE_MOTION_CHANNEL_NAME);
      channel.postMessage({ checked: newValue });
      channel.close();
    }
  }
}
